// Keeps each section's "Call agenda N/M" badge honest between ticks. The
// server renders the badge from persisted answers, but discovery_reveal
// shows/hides conditional talking points live (a gate flips to "Yes"), so the
// visible total changes before any tick round-trips. Recounts from the DOM
// whenever the reveal controller announces a refresh; a tick's Turbo Stream
// then replaces the badge with the server's figure, which agrees.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["badge"]

  update() {
    this.badgeTargets.forEach((badge) => {
      const items = [...this.element.querySelectorAll(`[data-agenda-item="${badge.dataset.section}"]`)]
        .filter((el) => !el.classList.contains("d-none"))
      const done = items.filter((el) => el.dataset.discussed === "true").length
      const complete = items.length > 0 && done === items.length

      badge.innerHTML = `${complete ? '<i class="fa-solid fa-check me-1"></i>' : ""}${done}/${items.length}`
      badge.classList.toggle("text-success", complete)
      badge.classList.toggle("text-secondary", !complete)
    })
  }
}
